var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconClearFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#00000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.54492 3.89258V4.88086L4.97559 7.30078L7.40527 9.71973V11.9463C7.40527 13.2021 7.41178 14.1701 7.41992 14.167C7.4351 14.1596 7.92436 13.869 8.51367 13.5176L9.59375 12.874L9.59473 11.2969V10.9424L10.6396 11.9873V13.4551L8.51465 14.7246C7.35254 15.4189 6.39397 15.9904 6.375 16C6.36674 16.0031 6.36035 14.7424 6.36035 13.0771V10.1494L3.92969 7.72949L1.5 5.31055V2.84766L2.54492 3.89258ZM3.20703 2H15.5V5.31055L13.0703 7.72949L10.998 9.79102L15.3301 14.123L14.623 14.8301L0.5 0.707031L1.20703 0L3.20703 2ZM10.2617 9.05469L12.0244 7.30078L14.4551 4.88086V3.04004H4.24707L10.2617 9.05469Z",
    fill: "#00000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClearFilter);
export default __webpack_public_path__ + "static/media/icon--clear-filter.320eb49c36d0a33454163bc6492f294a.svg";
export { ForwardRef as ReactComponent };